import { Component, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { RemoveDialogComponent } from 'src/app/remove-dialog/remove-dialog.component';
import {
  DriversService,
  UserAdministration,
  UserAdministrationEdit,
} from 'src/app/services/drivers.service';

@Component({
  selector: 'app-user-administration',
  templateUrl: './user-administration.component.html',
  styleUrls: ['./user-administration.component.css'],
})
export class UserAdministrationComponent {
  @ViewChild(MatTable)
  table!: MatTable<UserAdministration>;

  @ViewChild('paginator', { static: true }) paginator!: MatPaginator;

  displayedColumns: string[] = [];
  dataSource: any;
  constructor(private driversService: DriversService, private router: Router,  public dialog: MatDialog) {}

  ngOnInit(): void {
    this.displayedColumns = [
      'Nachname',
      'Vorname',
      'Pin',
      'MitarbeiterNr',
      'löschen',
    ];
    this.loadData();
  }

  removeData(item) {
    var dialogRef = this.openDialog('0ms', '0ms');
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log(result);
        this.driversService.delete(item.id).subscribe(
          (res) => {
            this.loadData();
          },
          (error) => {
            alert('Fehler beim Löschen');
          }
        );
      }
    });
  }

  loadData(): void {
    this.driversService.get().subscribe((data) => {
      this.dataSource = new MatTableDataSource<UserAdministration>(data);
      this.dataSource.paginator = this.paginator;

     this.dataSource.filterPredicate = (user: UserAdministration, filter: string) => {
       const searchStr = [
         user.firstName,
         user.lastName,
         user.pin,
         user.employeeNr,
       ].join(' ').toLowerCase();
       return searchStr.includes(filter);
     };
    });
  }

  entryClicked(row: UserAdministrationEdit): void {
    this.router.navigate([
      '/user-administration-edit',
      row.id,
      row.firstName,
      row.lastName,
      row.pin,
      row.employeeNr,
    ]);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openDialog(
    enterAnimationDuration: string,
    exitAnimationDuration: string
  ): MatDialogRef<RemoveDialogComponent, any> {
    var dialogref = this.dialog.open(RemoveDialogComponent, {
      width: '250px',
      enterAnimationDuration,
      exitAnimationDuration,
    });

    return dialogref;
  }
}